import {
  AbsenceApprovalStatus,
  ApprovalRequestStatus,
  ManagerReportsType,
  usePendingAbsenceRequestToMeQuery,
} from '../../../__generated__/graphql';

export const usePendingAbsenceRequests = (
  managerReportsType: ManagerReportsType,
) => {
  const { data, loading, error } = usePendingAbsenceRequestToMeQuery({
    variables: {
      managerReportsType,
    },
  });

  //TODO:: temp solution
  const pendingAbsenceRequestToMe =
    data?.me.approvalRequests.filter((request) => {
      if (request.absence) {
        if (
          request.absence.flair__Approval_Status__c !==
            AbsenceApprovalStatus.Pending &&
          request.flair__Approval_Status__c === ApprovalRequestStatus.Pending
        ) {
          return false;
        }
      }
      return true;
    }) ?? [];

  const sortedPendingAbsenceRequestToMe = pendingAbsenceRequestToMe.sort(
    (a, b) => {
      const aDate = a.absence?.flair__Start_Date__c ?? a.CreatedDate;
      const bDate = b.absence?.flair__Start_Date__c ?? b.CreatedDate;
      return new Date(bDate).getTime() - new Date(aDate).getTime();
    },
  );

  const filterOutWithoutAbsence = sortedPendingAbsenceRequestToMe.filter(
    (request) => {
      if (request.flair__Related_Object_Name__c !== 'flair__Absence__c') {
        return true;
      }
      return request.absence !== null;
    },
  );

  return {
    pendingAbsenceRequestToMe: filterOutWithoutAbsence,
    error,
    loading,
  };
};
